import React from 'react';
import TableWithPagination from '../table/TableWithPagination';

const BuzzlistTable = (props) => {
  const tablePageWindowSize = 10;
  const tableRowSize = 10;

  const buzzlistTableHeader = [`#/${props.resultData.body.hits.hits.length}`, 'Title', 'Channel', 'Published']
  const BuzzlistData = props.resultData.body.hits.hits;

  return(
    <div>
      <TableWithPagination
        tableType="BuzzlistTable"
        headerInfo={buzzlistTableHeader}
        bodyInfo={BuzzlistData}
        bodyLength={BuzzlistData.length}
        tablePageWindowSize={tablePageWindowSize}
        tableRowSize={tableRowSize}/>
      {/*  <TableWithPagination
         tableType="BuzzlistTable"
         headerInfo={buzzlistTableHeader}
         bodyInfo={BuzzlistData.data}
         bodyLength={BuzzlistData.dataLength}
         tablePageWindowSize={tablePageWindowSize}
         tableRowSize={tableRowSize}/> */}
    </div>
  )
}

export default BuzzlistTable;